import React from "react";
import MiniSubscriptioncardSkeleton from "./MiniSubscriptioncardSkeleton";

const SeeAllMiniPackagesSkeleton = () => {
  const arr = [1, 2, 3, 4, 5];

  return (
    <div className="flex flex-col">
      <div className="grid mt-10 lg:grid-cols-5 max-md:grid-cols-3 max-sm:grid-cols-2">
        {arr.map((item: any) => (
          <div key={item}>
            <MiniSubscriptioncardSkeleton />
          </div>
        ))}
      </div>
    </div>
  );
};

export default SeeAllMiniPackagesSkeleton;
